module.exports = __webpack_public_path__ + "static/img/begleitstaebe.71b6301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cat/begleitstaebe.png
// module id = 6y8C
// module chunks = 1